module.exports = __webpack_public_path__ + "static/img/error.c140d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.png
// module id = 3xxH
// module chunks = 4